import styled from 'styled-components';

const ActivitySidebar = styled.div`
  box-sizing: border-box;
  border-radius: 0.1875rem;
  width: 100%;
`;
export default ActivitySidebar;
